import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    loadingClass: String,
    disabledClass: String,
  }

  connect() {
    // find parent form
    this.form = this.element.closest('form')
    if (this.form == null) {
      const formAttr = this.element.getAttribute('form')
      if (formAttr !== null) {
        this.form = document.getElementById(formAttr)
      }
    }

    this.form?.addEventListener('submit', this.onSubmit)
  }

  disconnect() {
    this.form?.addEventListener('submit', this.onSubmit)
  }

  onSubmit = (e) => {
    if (!e.defaultPrevented) {
      this.element.disabled = true
      this.element.classList.add(this.loadingClassValue)
      this.element.classList.add(this.disabledClassValue)
    }
  }
}
